<template>
  <div class="pt-card-container route" v-loading="loading">
    <div class="pt-card-attributes">
      <component
        v-for="config in attributes"
        :key="config.id"
        :is="`card-${config.type}`"
        :feature="feature"
        :config="config"
      />
    </div>
    <card-buttons
      :feature="feature"
      :save="save"
      :cancel="cancel"
      :required="requiredProps"
    />
  </div>
</template>

<script>
import {
  clearAllHelpers,
  clearAllRouteGeometry
} from "@/libs/map-draw/helpers";
import CardInput from "./controls/card-input";
import CardRev from "./controls/card-rev";
import CardSelect from "./controls/card-select";
import CardButtons from "./controls/card-buttons";
import { getRouteAttributes } from "./config";

const getRequestConfig = id => ({
  where: [
    {
      field: "id",
      op: "=",
      value: id
    }
  ],
  include: {
    line_route_items: {
      only: ["node_id", "stop_point_id", "order_no"],
      include: {
        node: {
          only: ["id", "no", "geom"]
        },
        stop_point: {
          only: ["id", "no", "geom", "name"]
        }
      },
      where: [
        {
          field: "node_id",
          op: "!null",
          type: "OR",
          value: ""
        },
        {
          field: "stop_point_id",
          op: "!null",
          type: "OR",
          value: ""
        }
      ]
    }
  }
});
const removedProps = [
  "rev",
  "geom_length",
  "start_stop_point_name",
  "end_stop_point_name"
];

export default {
  props: ["mapgl", "draw", "state", "close-card"],
  components: {
    CardInput,
    CardRev,
    CardSelect,
    CardButtons
  },
  data() {
    return {
      loading: false,
      feature: {
        name: "",
        number: "",
        rev: false,
        distance_class: 1,
        transfer_type: 1,
        transport_system_id: null,
        carrier_id: "",
        geom_length: 0,
        start_stop_point_name: "",
        end_stop_point_name: ""
      },
      attributes: getRouteAttributes(
        this.$store.state.publicTransport.model.ids
      ),
      requiredProps: ["name", "number", "transport_system_id"]
    };
  },
  watch: {
    "$store.state.publicTransport.activeCardId": {
      handler: function(val) {
        if (!val) return;
        this.getInfo();
      }
    }
  },
  methods: {
    getInfo() {
      const { activeObject, mode } = this.state;
      const { properties } = activeObject;
      const { id, _updated } = properties;

      if (mode === "create") {
        this.setStopPointsNames(properties.line_route_items);
        return;
      }

      if (!id || _updated) {
        this.setInitialValues(properties);
      } else {
        this.getObjectData(id);
      }
    },
    async getObjectData(id) {
      try {
        this.loading = true;
        const { ids } = this.$store.state.publicTransport.model;
        const config = getRequestConfig(id);
        const url = `objectInfo/${ids["line_routes"]}?config=${JSON.stringify(
          config
        )}`;
        const { data } = await this.$store.dispatch("REQUEST", { url });

        this.setInitialValues(data[id]);

        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    setInitialValues(initial) {
      Object.keys(this.feature).forEach(key =>
        this.$set(this.feature, key, initial[key])
      );
      this.setStopPointsNames(initial.line_route_items);
    },
    setStopPointsNames(line_route_items) {
      const first = line_route_items[0];
      const last = line_route_items[line_route_items.length - 1];

      if (first.stop_point) {
        this.feature.start_stop_point_name =
          first.stop_point_name || first.stop_point.name;
      }
      if (last.stop_point) {
        this.feature.start_stop_point_name =
          last.stop_point_name || last.stop_point.name;
      }
    },
    cancel() {
      const { activeObject, mode } = this.state;
      if (mode === "create") this.draw.delete(activeObject.id);
      if (mode === "edit") this.draw.changeMode("simple_select");

      clearAllHelpers(this.mapgl);
      clearAllRouteGeometry(this.mapgl);
      this.closeCard();
    },
    save() {
      const {
        activeObject,
        editingCallback,
        creatingCallback,
        mode
      } = this.state;
      const callback = mode === "create" ? creatingCallback : editingCallback;

      Object.keys(this.feature)
        .filter(key => removedProps.indexOf(key) === -1)
        .forEach(key => {
          activeObject.setProperty(key, this.feature[key]);
        });
      activeObject.setProperty("_updated", true);

      callback(activeObject);
      this.closeCard();
    }
  },
  created() {
    this.getInfo();
  }
};
</script>

<style></style>
